import { MotionAndPositionCard } from "./MotionAndPositionCard";
export default MotionAndPositionCard;
